import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ContainerStationDetailWithContainersFragment = { __typename?: 'ContainerStation', id: string, name: string, store_id: string, epc_tag: string, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null }, store: { __typename?: 'Store', id: string, name?: string | null }, containers: Array<{ __typename?: 'ContainerStationContainer', id: string, name: string, owner_since: string, type_id: number, type_name: string, image_url?: string | null, size_helper?: string | null, status: Types.ContainerLocationStatus }> };

export const ContainerStationDetailWithContainersFragmentDoc = gql`
    fragment ContainerStationDetailWithContainers on ContainerStation {
  id
  name
  store_id
  item_type {
    id
    name
    color_hex_code
    category
    epc_asset_id
    image_url
  }
  epc_tag
  store {
    id
    name
  }
  containers {
    id
    name
    owner_since
    type_id
    type_name
    image_url
    size_helper
    status
  }
}
    `;